import React from 'react';
import { setCurrentView } from 'core/utils';
import { TrackingViewStore } from 'modules/order/stores';
import { TrackingTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new TrackingViewStore(rootStore), 'trackingViewStore')
class Tracking extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <TrackingTemplate {...this.props} />;
	}
}

export default Tracking;
